// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__gZk-4","box":"style_box__4cnFi","active":"style_active__dUHd0","title":"style_title__ZlgJn","item":"style_item__jWAL6"};